import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {ProductsType} from './products-type';

import {ProductsArticle} from './products-article';

@Injectable()
export class ProductsArticleService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private api_url_get_articles = './api/server.php?cmd=GET_ARTICLES';
    private api_url_insert_article = './api/server.php?cmd=INSERT_ARTICLE';
    private api_url_search_article = './api/server.php?cmd=SEARCH_ARTICLES';
    private api_url_get_types = './api/server.php?cmd=GET_TYPES';
    private api_url_get_new_internal_code = './api/server.php?cmd=GET_NEW_INTERNAL_CODE';
    private api_url_modify_article = './api/server.php?cmd=MODIFY_ARTICLE';
    private api_url_delete_article = './api/server.php?cmd=DELETE_ARTICLE';
    private api_url_verify_article_movement = './api/server.php?cmd=VERIFY_ARTICLE_MOVEMENT';
    private api_url_archive_article = './api/server.php?cmd=ARCHIVED_ARTICLE';
    private api_url_article_inferior_of_thershold = './api/server.php?cmd=GET_ARTICLE_INFERIOR_THERSHOLD';
    private api_url_get_article_by_id = './api/server.php?cmd=GET_ARTICLE_BY_ID';

    private id_article: number;
    private name: string;
    private supplier_code: string;
    private reference: string;
    private type: string;
    private category: string;
    private conditioning: string;
    private counting_unit: string;
    private description: string;
    private ht_bying_price: number;
    private ht_selling_price: number;
    private supply_thershold: string;
    private expiration_thershold: string;
    private managed_by_lot: string;
    private managed_by_serial: string;
    private issue_mode: string;
    private id_supplier: number;

    constructor(private http: Http) {}



    InsertArticle(article: ProductsArticle, supplier_list: string, location_list: string, dlc: any, for_sale: any): Promise<ProductsArticle[]> {
        this.name = article.name;
        this.supplier_code = article.supplier_code;
        this.reference = article.reference;
        this.type = article.type;
        this.category = article.category;
        this.conditioning = article.conditioning;
        this.description = article.description;
        this.counting_unit = article.counting_unit;
        // this.ht_bying_price = article.ht_bying_price;
        this.ht_selling_price = article.ht_selling_price;
        this.supply_thershold = article.supply_thershold;
        this.expiration_thershold = article.expiration_thershold;
        this.managed_by_lot = article.managed_by_lot;
        this.managed_by_serial = article.managed_by_serial;
        this.issue_mode = article.issue_mode;
        //this.id_supplier = article.id_supplier;

        return this.http.get(this.api_url_insert_article + '&name=' + this.name
            + '&supplier_code=' + this.supplier_code + '&type=' + this.type + '&category=' + this.category
            + '&conditioning=' + this.conditioning + '&description=' + this.description + '&counting_unit=' + this.counting_unit
            + '&ht_selling_price=' + this.ht_selling_price + '&supply_thershold=' + this.supply_thershold + '&expiration_thershold=' + dlc + '&managed_by_lot=' + this.managed_by_lot
            + '&managed_by_serial=' + this.managed_by_serial + '&issue_mode=' + this.issue_mode + '&locations=' + location_list + '&suppliers=' + supplier_list + '&stock_mini=' + article.stock_mini + '&stock_maxi=' + article.stock_maxi
            + '&for_sale=' + for_sale)
            .toPromise()
            .then(response => response.json() as ProductsArticle[])
            .catch(this.handleError);

    }

    EditArticle(article: any, suppliers: string, location_list_string: string, dlc: any, for_sale: any): Promise<ProductsArticle[]> {
        this.id_article = article.id_article;
        this.name = article.name;
        this.supplier_code = article.supplier_code;
        this.reference = article.reference;
        this.type = article.id_type;
        this.category = article.id_category;
        this.conditioning = article.conditioning;
        this.description = article.description;
        this.counting_unit = article.counting_unit;
        this.ht_selling_price = article.ht_selling_price;
        this.supply_thershold = article.supply_thershold;
        this.expiration_thershold = article.expiration_thershold;
        this.managed_by_lot = article.managed_by_lot;
        this.managed_by_serial = article.managed_by_serial;
        this.issue_mode = article.issue_mode;
        let stock_mini = article.stock_mini;
        let stock_maxi = article.stock_maxi;

        return this.http.get(this.api_url_modify_article
            + '&id_article=' + this.id_article
            + '&name=' + this.name
            + '&supplier_code=' + this.supplier_code + '&type=' + this.type + '&category=' + this.category
            + '&conditioning=' + this.conditioning + '&description=' + this.description + '&counting_unit=' + this.counting_unit + '&ht_bying_price=' + this.ht_bying_price
            + '&ht_selling_price=' + this.ht_selling_price + '&supply_thershold=' + this.supply_thershold + '&expiration_thershold=' + dlc + '&managed_by_lot=' + this.managed_by_lot
            + '&managed_by_serial=' + this.managed_by_serial + '&issue_mode=' + this.issue_mode + '&id_supplier=' + suppliers + '&locations=' + location_list_string + '&stock_mini=' + stock_mini + '&stock_maxi=' + stock_maxi
            + '&for_sale=' + for_sale)
            .toPromise()
            .then(response => response.json() as ProductsArticle[])
            .catch(this.handleError);

    }

    DeleteArticle(article: ProductsArticle): Promise<ProductsArticle[]> {
        this.id_article = article.id_article;

        return this.http.get(this.api_url_delete_article + '&id_article=' + this.id_article)
            .toPromise()
            .then(response => response.json()['list'] as ProductsArticle[])
            .catch(this.handleError);

    }

    VerifyMovement(article: ProductsArticle): Promise<Object> {
        this.id_article = article.id_article;

        return this.http.get(this.api_url_verify_article_movement + '&id_article=' + this.id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);

    }

    GetArticleById(id_article: any): Promise<ProductsArticle[]> {
        return this.http.get(this.api_url_get_article_by_id + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as ProductsArticle[])
            .catch(this.handleError);
    }

    GetArticlesList(): Promise<ProductsArticle[]> {
        return this.http.get(this.api_url_get_articles)
            .toPromise()
            .then(response => response.json() as ProductsArticle[])
            .catch(this.handleError);
    }
    GetTypesList(): Promise<ProductsType[]> {
        return this.http.get(this.api_url_get_types)
            .toPromise()
            .then(response => response.json() as ProductsType[])
            .catch(this.handleError);
    }
    GetNewInternalCode(): Promise<string> {
        return this.http.get(this.api_url_get_new_internal_code)
            .toPromise()
            .then(response => response.json() as string)
            .catch(this.handleError);
    }
    Search(internal_code: string, reference_code: string, name: string, category: string): Promise<ProductsArticle[]> {

        return this.http.get(this.api_url_search_article + '&internal_code=' + internal_code + '&reference_code=' + reference_code + '&name=' + name + '&category=' + category)
            .toPromise()
            .then(response => response.json() as ProductsArticle[])
            .catch(this.handleError);
    }

    ArchiveArticle(id_article: number): Promise<ProductsArticle[]> {

        return this.http.get(this.api_url_archive_article + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as ProductsArticle[])
            .catch(this.handleError);
    }

    GetArticleWhoStockInfOfThershold(): Promise<Object> {
        return this.http.get(this.api_url_article_inferior_of_thershold)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }


    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./src/app/products-article.service.ts